//  @flow
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Container, Grid, Divider } from "@mui/material";
import { Notification } from "components/Atoms";

import * as Actions from "actions/user/user.tryonpackages";
import * as BaseActions from "actions/user/user-base.actions";
import * as ActionTypes from 'constants/ActionTypes';

import ButtonComponent from "components/Button";
import { H2, H4 } from "components/CustomTypography";

import { isAuthorized } from "helpers/utils";

import "./styles.scss";
import UserTryOnHistorySlider from "components/elements/user/tryon/UserTryOnHistorySlider";
import UserProductTrackUserViewedSlider from "components/elements/user/products/UserProductTrackUserViewedSlider";
import UserProductRecommendedSlider from "components/elements/user/products/UserProductRecommendedSlider";

import TryOnPackageStore from "components/pages/user/TryOnPackages/TryOnPackageStore";

const MyShoppingOverall = (props) => {
  const [viewMode, setViewMode] = useState("PREVIEW");

  const history = useHistory();

  const {
    serviceError,
    reqStatus,
    tryonCredits,
    getTryOnCredits,
  } = props;

  useEffect(() => {
    getTryOnCredits();
  }, []);

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText || serviceError,
      };
      return sendNotification("error", feedback);
    }

    switch (reqStatus) {
      default:
        break;
    }
  }, [serviceError, reqStatus]);

  const handleBuyTryoutCredits = () => {
    setViewMode("TRYOUT_BUY");
  }


  const renderMain = () => (
    <Container>
      <Box className="credits-display-banner" mb={3} mt={2}>
        <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
          <Box>
            <H4 fontSize={14} color="textSecondary">Available Credits</H4>
            <H2 fontSize={32} fontWeight="bold" color="primary">
              {tryonCredits ? tryonCredits.balance || 0 : 0}
            </H2>
          </Box>
          <Box>
                <ButtonComponent
              type="primary"
              variant="contained"
              name="Buy Credits"
              size="medium"
              onClick={() => handleBuyTryoutCredits()}
            />
          </Box>
        </Box>
      </Box>

      <UserTryOnHistorySlider />

      <UserProductTrackUserViewedSlider includeHeader={true} />

      {isAuthorized() &&
        <Box sx={{ mb: 2 }}><UserProductRecommendedSlider includeHeader={true} /></Box>}


    </Container>
  );

  const renderTryOutPackages = () => (
      <Container>
        <TryOnPackageStore />
      </Container>
  );

  const renderView = () => {
    switch (viewMode) {
      case "TRYOUT_BUY":
        return renderTryOutPackages();
      case "PREVIEW":
      default:
        return renderMain();
    }
  };

  return (
    <Container>
      {renderView()}
    </Container>
  );
};

const mapStateToProps = ({ userbootupInfo, bootupInfo }) => ({
  bootupInfo,
  currency: bootupInfo.symbol,
  reqStatus: userbootupInfo.reqStatus,
  isLoading: userbootupInfo.isLoading,
  serviceError: userbootupInfo.serviceError,
  tryonCredits: userbootupInfo.tryonCredits,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...Actions, ...BaseActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyShoppingOverall);
